export default __webpack_public_path__ + "static/media/V220_SOV.6f46eb10.pdf";